// Note: genesysURL is globally declared in parent HTML block
// eslint-disable-next-line no-undef
const LIVE_AGENT_URL = genesysURL;

export async function genesysRequest(fullname, mob_islogin = "Pre Login", mob_cif, mob_nric, mob_inquiryselection = "Marina", mob_routingcategory = "Marina", mob_sourcechat, mob_preferredlanguage, GCTI_LanguageCode, mob_pvpbflag, mob_tacmobileno) {
    const genesysRequestUrl = `${LIVE_AGENT_URL}/genesys/2/chat/Mobile_Chat`;

    const genesesRequestData = {
        nickName: fullname || "Anonymous",
        firstName: fullname || "Anonymous",
        lastName: "|",
        "userData[mob_cif]": mob_cif,
        "userData[mob_nric]": mob_nric,
        "userData[mob_islogin]": mob_islogin,
        "userData[mob_inquiryselection]": mob_inquiryselection,
        "userData[mob_routingcategory]": mob_routingcategory,
        "userData[mob_sourcechat]": mob_sourcechat,
        "userData[mob_preferredlanguage]": mob_preferredlanguage,
        "userData[GCTI_LanguageCode]": GCTI_LanguageCode,
        "userData[mob_pvpbflag]": mob_pvpbflag,
        "userData[mob_tacmobileno]": mob_tacmobileno,
    };

    return fetch(genesysRequestUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(genesesRequestData)

    }).then(response => {
        if (!response.ok) {
            throw new Error("Request response was not ok");
        }
        return response.json();

    }).then(result => {
        return result;

    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });

}

export async function genesysRefresh(chatId, userId, secureKey, alias) {
    const genesysRefreshUrl = `${LIVE_AGENT_URL}/genesys/2/chat/Mobile_Chat/${chatId}/refresh`;

    return fetch(genesysRefreshUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
            chatId,
            userId,
            secureKey,
            alias,
        })

    }).then(response => {
        if (!response.ok) {
            throw new Error("Request response was not ok");
        }
        return response.json();

    }).then(result => {
        return result;

    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });

}

export async function genesysQueue(chatId) {
    const genesysQueueUrl = `${LIVE_AGENT_URL}/genesys/1/statistic/urs/call/@${chatId}/lvq?tenant=Environment`;

    return fetch(genesysQueueUrl, {
        method: "GET",
        headers: {
            "Authorization": "Basic bW9iaWxpdHk6bW9iaWxpdHkxMjM="
        },

    }).then(response => {
        if (!response.ok) {
            throw new Error("Queue response not ok");
        }
        return response.json();

    }).then(result => {
        console.log("queue Result", result);
        return result;

    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });
}

export async function genesysSend(chatId, userId, secureKey, alias, message) {
    const genesysSendUrl = `${LIVE_AGENT_URL}/genesys/2/chat/Mobile_Chat/${chatId}/send`;

    return fetch(genesysSendUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
            chatId,
            userId,
            secureKey,
            alias,
            message
        })

    }).then(response => {
        if (!response.ok) {
            throw new Error("Request response was not ok");
        }
        return response.json();

    }).then(result => {
        return result;

    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });
}

export async function genesysEnd(chatId, userId, secureKey, alias) {
    const genesysEndUrl = `${LIVE_AGENT_URL}/genesys/2/chat/Mobile_Chat/${chatId}/disconnect`;

    return fetch(genesysEndUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
            userId,
            secureKey,
            alias,
        })

    }).then(response => {
        if (!response.ok) {
            throw new Error("End chat response was not ok");
        }
        return response.json();

    }).then(result => {
        return result;

    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });
}
